module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAAXNSR0IArs4c6QAAAIRJREFUKBVjuDvT+D8IMwABjAaxQQAXH6aHCaIMlbw3y/gpsgi6ITA5sGbl9LOMMAEQzcLMYYrMR5eH83GZiqwZGxukjwUmQYohMJvhmmECMMOIoeGaibEZ3QK4ZnQJqtsMMhDZEvrajGw77WxG9h+2AKTIZkZi4hebrSAxrLkKl2J0cQA2ZD78zXuj5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-analysis-updated.png
// module id = 1ibG
// module chunks = 1 10 15 16 17 18 19 20